/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatSendMessageResponse } from '../../models/chat-send-message-response';

export interface ApiV1ChatsSendMessageToPlayersPost$Params {
  body: {
    message: string;
    sport_id?: number;
    team_id?: number;
    player_ids?: number[];
  };
}

export function apiV1ChatsSendMessageToPlayersPost(
  http: HttpClient,
  rootUrl: string,
  params: ApiV1ChatsSendMessageToPlayersPost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ChatSendMessageResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1ChatsSendMessageToPlayersPost.PATH, 'post');
  rb.body(params.body);

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => r as StrictHttpResponse<ChatSendMessageResponse>)
  );
}

apiV1ChatsSendMessageToPlayersPost.PATH = '/api/v1/chats/send-message-to-players';
